var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.33333C1 15.7472 10.2528 25 21.6667 25C22.1816 25 22.6922 24.9812 23.1977 24.9441C23.7778 24.9017 24.0679 24.8804 24.332 24.7284C24.5506 24.6025 24.7581 24.3793 24.8677 24.152C25 23.8776 25 23.5575 25 22.9173V19.1609C25 18.6226 25 18.3534 24.9114 18.1226C24.8331 17.9188 24.706 17.7373 24.5412 17.5941C24.3546 17.432 24.1017 17.34 23.5957 17.156L23.5957 17.156L19.3199 15.6012C18.7313 15.3871 18.437 15.2801 18.1577 15.2983C17.9115 15.3143 17.6746 15.3983 17.4733 15.541C17.245 15.7029 17.0838 15.9714 16.7616 16.5085L16.7616 16.5085L15.6667 18.3333C12.1335 16.7332 9.2692 13.8652 7.66667 10.3333L9.49151 9.23843C10.0286 8.91617 10.2971 8.75504 10.459 8.52675C10.6017 8.32544 10.6857 8.08849 10.7017 7.84226C10.7199 7.56302 10.6129 7.2687 10.3988 6.68006L8.84398 2.40428C8.66001 1.89835 8.56802 1.64538 8.40589 1.4588C8.26268 1.29399 8.08119 1.16686 7.87736 1.0886C7.64661 1 7.37744 1 6.83909 1H3.08268C2.4425 1 2.12241 1 1.84797 1.13234C1.62067 1.24194 1.39752 1.44935 1.2716 1.66804C1.11958 1.93209 1.09833 2.22216 1.05585 2.8023C1.01883 3.30781 1 3.81837 1 4.33333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.df570e5cb4c286415fbe835795ab0cfc.svg";
export { ForwardRef as ReactComponent };